module.exports = __webpack_public_path__ + "static/img/cj08.6f2bd9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj08.png
// module id = 151
// module chunks = 0